export default {
  redeemCode: {
    title: 'Tubusin ang Code',
    description: 'Ilagay ang iyong redeem code sa ibaba upang makuha ang iyong reward.',
    enterTip: 'Ilagay ang iyong redeem code para makuha ang mga gantimpala',
    label: 'Redeem Code',
    placeholder: 'Ilagay ang redeem code',
    submit: 'Tubusin',
    redeemBtn: 'I-REDEEM',
    submitting: 'Tinutubos...',
    success: 'Matagumpay na natubos ang code!',
    redeemSuccess: 'Matagumpay na natubos ang code!',
    failed: 'Nabigong tubusin ang code, pakisubukan muli.',
    redeemFailed: 'Nabigong tubusin ang code, pakisubukan muli.'
  }
};
